module.exports = __webpack_public_path__ + "img/location-de.d1d41adf.svg";